import React from 'react';
import './assets/detail.scss';
import { subscribe } from 'alfa';
import { Col, Descriptions, Icon, Row, Typography } from 'antd';
import QRCode from 'qrcode.react';
import { withTranslation } from 'react-i18next';

import getCLABE from '../../helpers/clabe';
import Link from '../../components/link';
import { BalanceDisplayer } from '../../components/balance-displayer/BalanceDisplayer';

const { Title } = Typography;

const AccountDetail = withTranslation()(({ account, t }) => {
  let clabe = <></>;
  if (account.region_id === 'MX') {
    clabe = (account.meta.clabe) ? (<Descriptions.Item label="CLABE" span={3}>{getCLABE(account.meta)}</Descriptions.Item>) : (<></>);
  }

  return (
    <>
      <Title level={3}>{t('account_details')}</Title>
      <Row gutter={10}>
        <Col xs={24} sm={18} md={18} lg={18} xl={18}>
          <Descriptions bordered>
            <Descriptions.Item label="Lana URL" span={3}>
              <a href={account.url} target="_blank" rel="noopener noreferrer">
                {account.url}
              </a>
            </Descriptions.Item>
            <Descriptions.Item label="Lana REF" span={3}>
              {account.ref}
            </Descriptions.Item>
            {clabe}
            <Descriptions.Item label={t('account.balance')} span={3}>
              <BalanceDisplayer account={account} showUpdatedAt className="linear" />
            </Descriptions.Item>
          </Descriptions>

          <ul className="button-list">
            <li>
              <Link button to={`/accounts/${account.id}/transactions`}>
                <Icon type="unordered-list" /> {t('transactions')}
              </Link>
            </li>
            <li>
              <Link button to={`/accounts/${account.id}/batches`}>
                <Icon type="upload" /> {t('batches')}
              </Link>
            </li>
          </ul>
        </Col>

        <Col xs={24} sm={6} md={6} lg={6} xl={6} style={{ textAlign: 'center', padding: '20px' }}>
          <QRCode value={account.url} size={190} />
        </Col>
      </Row>
    </>
  );
});

export default subscribe(AccountDetail, ['account']);
